import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Creators as organizerActions } from '@/domain/useCases/events/getOrganizer';

export const useOrganizer = () => {
  const dispatch = useDispatch();
  const { data } = useSelector((state: any) => state.getOrganizer);
  useEffect(() => {
    if (!data) dispatch(organizerActions.getOrganizer());
  }, []);

  const organizerList = [
    { value: 'Todos', label: 'Todos' },
    ...(data?.map((org: any) => ({
      value: org.name,
      label: org.name
    })) ?? [])
  ];

  return { organizerList };
};
